// extracted by mini-css-extract-plugin
export default {"container":"s2-z","heading":"t2-z","links":"u2-z","copy":"v2-z","subCopy":"w2-z","linksLeft":"x2-z","linksCenter":"y2-z","linksRight":"z2-z","link":"A2-z","onlyLink":"B2-z"};